import BaseEntity     from '@/core/misc/BaseEntity';
import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';
import Sticker from "@/domains/Stickers/Sticker";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

/**
 * Транспортная зона — логическое объединение складов для расчёта тарифов доставки
 */
@Title_ru_RU_Class('Транспортная зона')
class TransportZone extends BaseEntity {

	static Events = {
		Created: 'TransportZone:created',
		Updated: 'TransportZone:updated',
		Deleted: 'TransportZone:deleted',
	} as const;

	@Title_ru_RU('Наименование зоны', TYPES.STRING)
	public name: string;

	public sticker: Sticker | null;

	// ============================================================
	// Constructors
	// ============================================================

	/**
	 * Создаёт новую пустую зону
	 */
	static fromNew(): TransportZone {
		return new this();
	}

	/**
	 * Гидратирует зону из данных сервера
	 */
	static fromServer(data: any, result = new TransportZone()): TransportZone {
		super.fromServer(data, result);

		result.sticker = data?.sticker ? Sticker.fromServer(data?.sticker, new Sticker()) : null;

		return result;
	}

	// ============================================================
	// Validation
	// ============================================================

	/**
	 * Валидирует зону перед сохранением
	 */
	validate(): string[] {
		const errors: string[] = [];

		if (!this.name || this.name.trim() === '') {
			errors.push('Укажите наименование зоны');
		}

		return errors;
	}

  toString(): string {
    return this.name;
  }
}

export default TransportZone;
